import React from 'react'
import { Link } from 'gatsby'
import { useLocalization } from 'gatsby-theme-i18n'
import { lanLinks } from 'js/translations.js'

const LanLink = () => {
  const { locale } = useLocalization()
  const otherLanLink = locale === 'en' ? lanLinks.zh : lanLinks.en
  return (
    <Link className='lan-link' to={otherLanLink.urlBase + '/'}>
      <span>{otherLanLink.title}</span>
    </Link>
  )
}

export default LanLink
